import type { SVGProps } from 'react';

const SvgBottomBarHome = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height='1em'
    viewBox='0 0 25 24'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M21.645 11.917a1.383 1.383 0 0 0-.443-1.025L12.645 3l-8.557 7.892a1.385 1.385 0 0 0-.443 1.025v7.698A1.385 1.385 0 0 0 5.03 21h15.23a1.385 1.385 0 0 0 1.385-1.385v-7.698ZM12.645 21V15.46'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
    />
  </svg>
);
export default SvgBottomBarHome;
